import React, { useState, useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { P as Prices } from './Prices-J1SqTpik.js';
import { getProductLinkFromUrlRewrites } from './utils/product.js';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';
import Button from './components/Button/index.js';
import Link from './components/Link/index.js';
import { getPrices } from './utils/price.js';
import { CoreContext } from './context/index.js';
import { processErrorMessage } from './utils/error.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-sNwiaBfD.js';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { d as dataLayerSelectItemAccor } from './selectItem-PWuzvZX7.js';
import useItemListName from './hooks/useItemListName.js';
import { getCartSessionId } from './utils/cart.js';
import { a as ProductType } from './product-_pRduMz7.js';
import './utils/currency.js';
import WishlistButton from './components/WishlistButton/index.js';

const FeaturedProductItem = ({ item, wishlistButton = false, imgWidth, imgHeight, onAddToCart, }) => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const [isAdding, setIsAdding] = useState(false);
    const { asPath, locale } = useRouter();
    const { useDispatch, thunks: { cart: { getCart, addProduct }, }, data: { siteConfig: { siteName, parentHotelCompany, productNameFilters, accorTagging: { accorTaggingEnabled = false } = {}, noZeroAfterDecimal = null, }, }, } = useContext(CoreContext);
    const itemListName = useItemListName('cross sell');
    const dispatch = useDispatch();
    const showError = useShowError();
    const getPayload = (itemToAdd) => [
        {
            data: {
                quantity: 1,
                sku: itemToAdd.sku,
            },
        },
    ];
    const getConfigurableProductPayload = (product) => ({
        parent_sku: product.parent_sku,
        data: {
            sku: product.sku,
            quantity: 1,
        },
    });
    const handleAddToCart = async (itemToAdd, e) => {
        e.preventDefault();
        setIsAdding(true);
        let dispatchPayload;
        if (itemToAdd.type_id === ProductType.Configurable) {
            dispatchPayload = {
                configurableProducts: [getConfigurableProductPayload(itemToAdd)],
                accorTaggingEnabled,
                itemListName,
            };
        }
        else {
            dispatchPayload = {
                simpleProducts: getPayload(itemToAdd),
                accorTaggingEnabled,
                itemListName,
            };
        }
        const resultAction = await dispatch(addProduct(dispatchPayload));
        // let cartAction: any = null
        if (addProduct.fulfilled.match(resultAction)) {
            // setJustAddedData(resultAction.payload);
            // Run getCart() to update MiniShoppingCart popup data
            if (accorTaggingEnabled) {
                const resultPayload = resultAction.payload;
                resultPayload.item_selected.forEach(selectedItem => {
                    dataLayerSelectItemAccor({
                        product: selectedItem,
                        affiliation: parentHotelCompany,
                        brand: siteName,
                        siteFilters: productNameFilters,
                        index: 0,
                        itemListName,
                    });
                });
            }
            await dispatch(getCart({ cart_id: getCartSessionId(), accorTaggingEnabled }));
            if (onAddToCart) {
                onAddToCart();
            }
        }
        else {
            const error = processErrorMessage(resultAction.payload.errorMessage, t);
            showError(error);
        }
        setIsAdding(false);
    };
    const prices = getPrices(item.price_range, locale, noZeroAfterDecimal);
    const imgUrl = item.thumbnail.url;
    return (React.createElement("div", { className: "featured-product" },
        React.createElement("div", { className: "wrapper" },
            wishlistButton && React.createElement(WishlistButton, { product: item }),
            React.createElement(Link, { href: getProductLinkFromUrlRewrites(item.url_rewrites, locale), ariaLabel: tLabel('shop', { productName: item.name }), className: "img", noUnderline: true },
                React.createElement("img", { src: imgUrl, className: "upsell-items-img", alt: t('$common.productName', { productName: item.name }), loading: "lazy", ...(imgWidth && { width: imgWidth }), ...(imgHeight && { height: imgHeight }), onError: () => logImgLoadErrorToRelic(asPath, imgUrl) })),
            React.createElement("div", { className: "inner-wrapper" },
                React.createElement(Link, { href: getProductLinkFromUrlRewrites(item.url_rewrites, locale), ariaLabel: tLabel('shop', { productName: item.name }), className: "upsell-items-link", noUnderline: true },
                    React.createElement("p", { className: "title-featured" }, item.name),
                    React.createElement(Prices, { show: true, prices: prices, className: "product-config-prices" })),
                React.createElement(Button, { variant: "plain", className: "product-add-to-bag base-btn bg-red", isLoading: isAdding, onClick: e => handleAddToCart(item, e) }, tButton('addToCart'))))));
};

export { FeaturedProductItem as F };
//# sourceMappingURL=FeaturedProductItem-3H1owsmv.js.map
